import { useNavigate } from "react-router-dom";
import { ArrowRight, Target, Heart, ShieldCheck, Users } from "lucide-react";
import { Button } from "../components/ui/button";
import SeoHead from "../components/SeoHead";
import { STATS } from "../data/content";
import { APP_MOCKUP } from "../data/content";

const VALUES = [
  { icon: "ShieldCheck", title: "Trust first", desc: "Every professional is verified so your home is in safe hands." },
  { icon: "Heart", title: "Local at heart", desc: "We empower neighbourhood professionals and the communities they serve." },
  { icon: "Target", title: "Simple & fast", desc: "Booking a trusted pro should take a minute, not a day." },
  { icon: "Users", title: "Fair for all", desc: "Transparent pricing for customers, fair earnings for partners." },
];
const ICONS = { ShieldCheck, Heart, Target, Users };

export default function AboutPage() {
  const navigate = useNavigate();
  return (
    <div>
      <SeoHead title="About ApnaFix - Local Home Services Marketplace" description="ApnaFix connects residents with trusted local service professionals in their area. Learn about our mission." />
      <div className="bg-navy text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-xs uppercase tracking-widest font-bold text-orange-300">About ApnaFix</p>
            <h1 className="mt-2 font-display text-3xl sm:text-5xl font-extrabold tracking-tight">Built around your local community</h1>
            <p className="mt-4 text-slate-300 max-w-lg leading-relaxed">ApnaFix connects residents with trusted, verified local service professionals in their area — from AC repair and electricians to cleaning and moving. Our mission is simple: make it effortless to find reliable help for any local problem, while helping skilled professionals grow their business.</p>
            <Button onClick={() => navigate("/book")} className="mt-6 bg-brand-orange hover:bg-orange-600 text-white font-bold h-12 px-6">Book a Service <ArrowRight className="w-4 h-4 ml-1" /></Button>
          </div>
          <img src={APP_MOCKUP} alt="ApnaFix app preview" className="rounded-3xl border border-white/10 shadow-2xl w-full max-w-xs mx-auto" />
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {STATS.map((s) => (
            <div key={s.label} className="rounded-2xl border border-slate-200 bg-white p-5 text-center">
              <p className="font-mono-num text-2xl sm:text-3xl font-bold text-navy">{s.value}</p>
              <p className="text-xs text-slate-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-slate-400 -mt-8 mb-12">* Sample figures for launch — to be replaced with live numbers.</p>

        <h2 className="font-display text-2xl font-bold text-slate-900 text-center">What we stand for</h2>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {VALUES.map((v) => {
            const I = ICONS[v.icon];
            return (
              <div key={v.title} className="rounded-2xl border border-slate-200 bg-white p-5 hover:-translate-y-1 transition-transform">
                <span className="grid place-items-center w-11 h-11 rounded-xl bg-orange-50 text-brand-orange"><I className="w-5 h-5" /></span>
                <h3 className="mt-3 font-display font-bold text-slate-900">{v.title}</h3>
                <p className="mt-1 text-sm text-slate-600">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
